import { render } from "./HelpPopupButton.vue?vue&type=template&id=6ae26ead&scoped=true&ts=true"
import script from "./HelpPopupButton.ts?vue&type=script&lang=ts"
export * from "./HelpPopupButton.ts?vue&type=script&lang=ts"

import "./HelpPopupButton.scss?vue&type=style&index=0&id=6ae26ead&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae26ead"]])

export default __exports__